import { Label } from '@ordo/ui/label'
import { Switch } from '@ordo/ui/switch'

export function ShowInactiveToggle({
  checked,
  onCheckedChange,
  label = 'Show inactive',
  id = 'show-inactive',
}: {
  checked: boolean
  onCheckedChange: (value: boolean) => void
  label?: string
  id?: string
}) {
  return (
    <div className="flex items-center gap-2">
      <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} />
      <Label htmlFor={id} className="text-sm text-muted-foreground">
        {label}
      </Label>
    </div>
  )
}
